<div class="admincont">
  <div class="adminmenu">
    <app-query></app-query>
  </div>
  <div class="adminmain">
    <router-outlet></router-outlet>
  </div>
</div>